module.exports = __webpack_public_path__ + "img/riwayat-inactive.bb01247.png";